// extracted by mini-css-extract-plugin
export default {"ModalBtn":"ModalBtn_ModalBtn__41uWA"};